import { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { List } from "../../../../themes/Default/components/List";
import { Header as ListHeader } from "../../../../themes/Default/components/List/components/Header";
import { Body as ListBody } from "../../../../themes/Default/components/List/components/Body";
import { TableHead } from "../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableBody } from "../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableRow } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableDataCell } from "../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Title as ListTitle } from "../../../../themes/Default/components/List/components/Header/components/Title";
import { studentsManagement } from "../../../../hooks/api/StudentsManagement";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { useTranslation } from "react-i18next";
import { Slide, toast, ToastContainer } from "react-toastify";
import { Title } from "../../../../themes/Default/components/Title";
import { Formik } from "formik";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import { groupsManagement } from "../../../../hooks/api/GroupsManagement";
import { prepareSelect } from "../../../../services/core/Select";
import { Checkbox } from "../../../../themes/Default/components/Form/components/Checkbox";
import { Toaster } from "../../../../themes/Default/components/Toaster";

const Groups = () => {
    const { t } = useTranslation("common");
    const navigate = useNavigate();
    const formRef = useRef(null);
    const [student, setStudent] = useState();
    const { studentId } = useParams();
    const {  useViewStudentsMutation} = studentsManagement;
    const [viewStudents] = useViewStudentsMutation();
    const [groups, setGroups] = useState([]);
    const [selectedGroupId, setSelectedGroupId] = useState(null);

    const { useAddGroupParticipantsMutation, useGroupsListMutation } = groupsManagement;
    const [addGroupParticipants] = useAddGroupParticipantsMutation();
    const [viewGroups] = useGroupsListMutation();
    const [groupsList, setGroupsList] = useState([]);

    const gotoDetailsTab = (studentId) => {
        navigate("/students/edit/" + studentId);
    };

    const gotoNotesTab = (studentId) => {
        navigate('/students/' + studentId + '/notes');
    }

    const gotoTestsTab = (studentId) => {
        navigate('/students/' + studentId + '/tests');
    }

    const gotoDocumentsTab = (studentId) => {
        navigate('/students/' + studentId + '/documents');
    }

    const gotoCertificatesTab = (studentId) => {
        navigate('/students/' + studentId + '/certificates');
    }

    const gotoContractsTab = (studentId) => {
        navigate("/students/" + studentId + "/contracts");
    };

    const gotoCallsTab = (studentId) => {
        navigate("/students/" + studentId + "/calls");
    };

    const tabs = [
        { title: t('details'), onClick: () => gotoDetailsTab(studentId) },
        // { title: t('students.tests'), onClick: () => gotoTestsTab(studentId)},
        { title: t("students.contract"), onClick: () => gotoContractsTab(studentId) },
        { title: t("calls.title"), onClick: () => gotoCallsTab(studentId) },
        { title: t('groups.title'), isActive: true},
        { title: t('students.certificates'), onClick: () => gotoCertificatesTab(studentId)},
        { title: t('documents'), onClick: () => gotoDocumentsTab(studentId)},
        { title: t('notes'), onClick: () => gotoNotesTab(studentId)},
    ];

    const gotoViewArchiveNote = (groupId) => {
        navigate("/students/" + studentId + "/groups/" + groupId + "/view-archive-note");
    };

    const gotoEditGroup = (groupId) => {
        navigate("/groups/edit/" + groupId);
    };

    const onArchiveGroupParticipant = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        navigate("/students/" + studentId + "/groups/" + selectedGroupId + "/archive-note");
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    const onSelectionChange = (id) => {
        if (selectedGroupId === id) {
            setSelectedGroupId(null); 
        } else {
            setSelectedGroupId(id); 
        }
    };

    const loadStudent = () => {
        viewStudents(studentId).then((result) => {
            setGroups(result?.data?.groups);
            setStudent(result?.data);
        });
    }

    useEffect(() => {
        loadStudent();

        viewGroups().then((result) => {
            let options = [];
            result?.data?.records.map((group) => {
                options.push(
                    {
                        id: group.id,
                        name: group.name + ' - ' + group.languageName
                    }
                );
            })
            setGroupsList(prepareSelect(options));
        });
    }, []);

    return (
        <DefaultLayout>
            <TopNavigation>
                <ButtonBack to="/students" />
                <Button title={t("Arhiviraj polaznika u grupi")} icon="fa-regular fa-box-archive" onClick={onArchiveGroupParticipant} isDisabled={selectedGroupId === null ||  groups.find(g => g.id === selectedGroupId)?.studentStatus}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>
                    {student?.firstName} {student?.lastName}
                </Title>
                <Breadcrumps>
                    <Link title={t('students.title')} icon="fa-user-graduate" />
                    <Link title={t('details')} />
                    <Link title={t('groups.title')} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{ 
                        group: "", 
                    }}
                >
                    {({ values, handleChange, setFieldValue, resetForm }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Select 
                                        label="Odaberi grupu:"
                                        name="group" 
                                        options={groupsList}  
                                        selectedValue={values.group}
                                        onChange={(event) => {
                                            console.log(event.target.value)
                                            setFieldValue('group', event.target.value);
                                            const body = {
                                                participants: [studentId]
                                            };
                                            addGroupParticipants({body, groupId:event.target.value}).then((result) => {
                                                resetForm();
                                                loadStudent();
                                            });
                                        }}
                                        searchInDropdown={false}
                                    />
                                </Field>
                                <Field></Field>
                            </Row>
                        </Form>
                    )}
                </Formik>
                <br/>
                <List>
                    <ListHeader>
                    </ListHeader>
                    <ListBody>
                        <TableHead>
                            <TableRow>
                                <TableHeadCell><span></span></TableHeadCell>
                                <TableHeadCell><span></span></TableHeadCell>
                                <TableHeadCell><span>{t("Status studenta")}</span></TableHeadCell>
                                <TableHeadCell><span>{t("Status grupe")}</span></TableHeadCell>
                                <TableHeadCell><span>{t("groups.name")}</span></TableHeadCell>
                                <TableHeadCell><span>{t("groups.language")}</span></TableHeadCell>
                                <TableHeadCell><span>{t("groups.languageProgram")}</span></TableHeadCell>
                                <TableHeadCell><span>{t("groups.classNumber")}</span></TableHeadCell>
                                <TableHeadCell><span>{t("groups.classDuration")}</span></TableHeadCell>
                                <TableHeadCell><span></span></TableHeadCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {groups?.length > 0 &&
                            groups?.map((group, index) => {
                                return (
                                    <TableRow key={index}>
                                        <TableDataCell>
                                            {group.studentStatus ? (
                                                <Button
                                                    icon="fa-regular fa-eye"
                                                    onClick={() => gotoViewArchiveNote(group.id)}
                                                ></Button>
                                            ) : null}
                                        </TableDataCell>
                                        <TableDataCell>
                                            <Checkbox
                                            name="selectedGroup"
                                            value={group.id}
                                            checked={selectedGroupId === group.id}
                                            onChange={() => onSelectionChange(group.id)}
                                            />
                                        </TableDataCell>
                                        <TableDataCell>
                                            <span style={{ color: group.studentStatus ? '#ff0000' : '#27ae60' }}>
                                                {group.studentStatus ? t("Arhiviran") : t("Aktivan")}
                                            </span>
                                        </TableDataCell>
                                        <TableDataCell>
                                            <span style={{ color: group.isArchived ? '#ff0000' : '#27ae60' }}>
                                                {group.isArchived ? t("groups.isArchived") : t("active")}
                                            </span>
                                        </TableDataCell>
                                        <TableDataCell>
                                            <Button 
                                                title={group.name}
                                                onClick={() => gotoEditGroup(group.id)}
                                            />
                                        </TableDataCell>
                                        <TableDataCell>{group.languageName}</TableDataCell>
                                        <TableDataCell>{group.languageProgramName}</TableDataCell>
                                        <TableDataCell>{group.classNumber}</TableDataCell>
                                        <TableDataCell>{group.classDuration}</TableDataCell>
                                        <TableDataCell></TableDataCell>
                                    </TableRow>
                                )
                        })}
                        </TableBody>
                    </ListBody>
                </List>
            </Main>
        </DefaultLayout>
    );
};

export default Groups;
